import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { curveBasis as d3curveBasis, curveLinear as d3curveLinear } from 'd3'
import DagreGraph from 'dagre-d3-react'

import { ORGS, IOrgs } from '../../../../../dict/ORGS'
import { DagreLink, DagreNode } from './types'
import { getNodes, getLinks } from './functions'
import './style.scss'
import { DagreContainer } from './Container'
import { toJS } from 'mobx'
import RootStoreContext from '../../../../../storage/RootStore'

/// functions
/// types
/// components

interface StructureProps {
}

export const Structure: React.FC<StructureProps> = observer(() => {

    const dagreRef = useRef(null)
    const { selection, dimensions } = useContext(RootStoreContext)

    // const [nodes, setNodes] = useState<DagreNode[]>([])
    // const [links, setLinks] = useState<DagreLink[]>([])

    // useEffect(() => { setNodes(getNodes(ORGS)) }, [])
    // useEffect(() => { setLinks(getLinks(ORGS)) }, [])

    const nodes = useMemo(() => getNodes(ORGS),[])
    const links = useMemo(() => getLinks(ORGS),[])

    useEffect(() => {
        if (true){
            document.querySelectorAll('.node').forEach(node => {
                let labelDiv = node.querySelector('tspan');

                let orgID = node.getAttribute('id');

                if (selection.org === orgID){
                    node.classList.add('node-selected')
                }

                console.log(orgID)
                // console.log(labelDiv)
                console.log('--')
                // let orgID = labelDiv.getAttribute('id')
                // let rect = node.querySelector('rect');
    
                // // console.log(labelDiv)
                // console.log(orgID, selection.org)
                // if (orgID === selection.org){
                    
                //     node.classList.add('node-selected')
                // } else {
                //     node.classList.remove('node-selected')
                // }  
            })
        }
       
    }, [selection.org])


    useEffect(() => {
        document.querySelectorAll('.node').forEach(node => {
            node.addEventListener('click', event => {
                document.querySelectorAll('.node').forEach(node => node.classList.remove('node-selected'))

                let ct = event.currentTarget as SVGAElement
                // console.log(ct)

                // let labelDiv = ct.querySelector('.structure-label');
                // let orgID = labelDiv.getAttribute('id')

                // selection.setOrg(orgID)
                ct.classList.add('node-selected')
            })
        })
    }, [])

    return (
        <DagreGraph
            key={'dagre'}
            nodes={nodes}
            ref={dagreRef}
            links={links}
            className={'dagre-svg'}
            config={{
                // rankdir: "TB",
                rankdir: "LR",
                // acyclicer: 'greedy',
                // align: 'UL',
                ranksep: 55, //50
                nodesep: 15, // 50 
                edgesep: 15, //10
                // ranker: "tight-tree",   
                ranker: "network-simplex",
                // ranker: "longest-path",   
                node: {
                    width: 250,
                    // height: 50,
                    labelOffset: 100
                },
                graph: {
                    className: 'graph-class'
                },
                edge: {
                    arrowheadStyle: 'display: none',
                    curve: d3curveLinear,
                    labelOffset: 50,
                }
            }}

            width={`${dimensions.WIDTH_STRUCTURE}`}
            height={`${dimensions.HEIGHT_STRUCTURE}`}
            // height={isDesktop ? '550' : '800'}
            animate={0}
            shape='rect'
            fitBoundaries
            zoomable
            onNodeClick={e => {
                // console.log(e)
                let id = toJS(e.original).id;
                // console.log(id)
                // console.log(id)
                selection.setOrg(id)
            }}
        />
    )
})






const Dagre = (props: {
    nodes: DagreNode[]
    links: DagreLink[]
    width: number,
    height: number,
    setter: (v: string) => void
}) => {


    return (
        <DagreGraph
            key={'dagre'}
            nodes={props.nodes}
            // ref={dagreRef}
            links={props.links}
            className={'dagre-svg'}
            config={{
                // rankdir: "TB",
                rankdir: "LR",
                // acyclicer: 'greedy',
                // align: 'UL',
                ranksep: 55, //50
                nodesep: 15, // 50 
                edgesep: 15, //10
                // ranker: "tight-tree",   
                ranker: "network-simplex",
                // ranker: "longest-path",   
                node: {
                    width: 250,
                    // height: 50,
                    labelOffset: 100
                },
                graph: {
                    className: 'graph-class'
                },
                edge: {
                    arrowheadStyle: 'display: none',
                    curve: d3curveLinear,
                    labelOffset: 50,
                }
            }}

            width={`${props.width}`}
            height={`${props.height}`}
            // height={isDesktop ? '550' : '800'}
            animate={0}
            shape='rect'
            fitBoundaries
            zoomable
            onNodeClick={e => {
                console.log(e)
                let id = toJS(e.original).id;
                console.log(id)
                console.log(id)
                props.setter(id)
                // selection.setOrg(id)
            }}
        />
    )
}